/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import { useAddCheckImage, useCheckImages, useDeleteCheckImage } from "../../../../../hooks/useCheckImages";
import ManualImages from "../ManualImages";

// Use for create purchase order reports
// Where we can have multiple check in one view
export default function CheckImages({ tenant_id, check_id, required_images }) {
    const tenantId = tenant_id;
    const { data: images = [], isLoading } = useCheckImages(tenantId, check_id);
    const addImageMutation = useAddCheckImage();
    const deleteImageMutation = useDeleteCheckImage();

    const addCheckImage = async (type, base64, focusMode) => {
        return addImageMutation.mutateAsync({ tenantId, checkId: check_id, type, base64, focusMode });
    };

    const deleteCheckImage = async (image) => {
        return deleteImageMutation.mutateAsync({ tenantId, checkId: check_id, image });
    };

    return <div>

        {required_images && <div>
            <ManualImages
                images={images || []}
                required_images={required_images}
                saveImage={addCheckImage}
                deleteImage={deleteCheckImage}
                isLoading={isLoading || addImageMutation.isPending || deleteImageMutation.isPending}
            />
        </div>}

    </div>;
}

CheckImages.propTypes = {
    tenant_id: PropTypes.string.isRequired,
    check_id: PropTypes.number,
    required_images: PropTypes.array
};
